import React from 'react';
import Layout from '../components/base/Layout';
import TeamsBody from '../components/Teams/TeamsBody';

const Teams = () => {
    return (
        <Layout>
            <TeamsBody />
        </Layout>
    );
};

export default Teams;
